import React from "react";
import {SidebarNew} from "./SidebarNew";

export const Sidebar = () => {
  return <SidebarNew />;
};
